import { array, boolean, mixed, number, object, string } from "yup";
import {
  CurrentSubscriptionFeatureResource,
  currentSubscriptionFeatureResourceSchema,
} from "./CurrentSubscriptionFeatureResource";
import {
  SubscriptionItemResource,
  subscriptionItemResourceSchema,
} from "./SubscriptionItemResource";

export enum CurrentSubscriptionStatus {
  Trialing = "trialing",
  Active = "active",
  PastDue = "past_due",
  Suspended = "suspended",
  Expired = "expired",
}

export enum SubscriptionPlanCode {
  TRIAL = "trial",
  GROWTH = "growth",
  UNLIMITED_GROWTH = "unlimited_growth",
  UNLIMITED_GROWTH_AI = "unlimited_growth_ai",
  STARTER = "starter",
  SCALE = "scale",
  COLLEGE = "college",
  FREE = "free",
  ENTERPRISE = "enterprise",
  PROAI = "pro_ai",
  PRO = "pro",
  FLEX = "flex",
}
interface CurrentSubscriptionPlan {
  id: number;
  name: string;
  code: SubscriptionPlanCode;
}

export interface CurrentUsagePeriod {
  startsAt: string | null;
  endsAt: string | null;
}

export interface BillingCycle {
  type: "one_time" | "recurring";
  intervalUnit: "day" | "month" | "year" | null;
}
export interface CurrentSubscriptionResource {
  uuid: string;
  plan: CurrentSubscriptionPlan | null;
  status: CurrentSubscriptionStatus;
  cancelAtPeriodEnd: boolean;
  createdAt: string;
  startsAt: string;
  endsAt: string | null;
  currentUsagePeriod: CurrentUsagePeriod;
  currentPeriod: CurrentUsagePeriod | null;
  features: CurrentSubscriptionFeatureResource[];
  billingCycle: BillingCycle;
  items: SubscriptionItemResource[];
  nextBillingAt: string | null;
}

const currentSubscriptionPlanSchema = object({
  id: number().required(),
  name: string().required(),
  code: mixed<SubscriptionPlanCode>()
    .oneOf(Object.values(SubscriptionPlanCode) as SubscriptionPlanCode[])
    .required(),
});

const currentUsagePeriodSchema = object({
  startsAt: string().nullable().default(null),
  endsAt: string().nullable().default(null),
});

const billingCycleSchema = object({
  type: mixed<"one_time" | "recurring">()
    .oneOf(["one_time", "recurring"])
    .required(),
  intervalUnit: mixed<"day" | "month" | "year">()
    .oneOf(["day", "month", "year"])
    .nullable()
    .default(null),
});
export const currentSubscriptionResourceSchema = object({
  uuid: string().required(),
  plan: currentSubscriptionPlanSchema.nullable().default(null),
  status: mixed<CurrentSubscriptionStatus>()
    .oneOf(
      Object.values(CurrentSubscriptionStatus) as CurrentSubscriptionStatus[],
    )
    .required(),
  cancelAtPeriodEnd: boolean().required(),
  createdAt: string().required(),
  startsAt: string().required(),
  endsAt: string().nullable().default(null),
  currentUsagePeriod: currentUsagePeriodSchema.required(),
  currentPeriod: currentUsagePeriodSchema.nullable().default(null),
  features: array().of(currentSubscriptionFeatureResourceSchema).required(),
  billingCycle: billingCycleSchema.required(),
  items: array().of(subscriptionItemResourceSchema).required(),
  nextBillingAt: string().nullable().default(null),
});
